import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store/index'
//Configuración de Fechas 
import * as dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale('es')
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
